const showMenu = (item1, item2, body, iframemainarea, gnbbtn) => {
  const toggle = document.querySelector(item1)
  const navbar = document.querySelector(item2)
  const mainbody = document.querySelector(body)
  const iframemain = document.querySelector(iframemainarea)
  const gnbToggleBtn = document.querySelector(gnbbtn)
  const menu = document.querySelectorAll('.depth1-item')
  for (let i = 0; i < menu.length; i++) {
    menu[i].addEventListener('click', function () {
      if (navbar.classList.contains('contract')) {
        navbar.classList.remove('contract')
        mainbody.style.marginLeft = 328 + 'px'
        iframemain.style.marginLeft = 328 + 'px'
      }
    })
  }
  if (toggle && navbar) {
    toggle.addEventListener('click', () => {
      navbar.classList.toggle('contract')
      mainbody.classList.toggle('contract')
      if (navbar.classList.contains('contract')) {
        const lnbWidth = navbar.offsetWidth
        mainbody.style.marginLeft = lnbWidth + 'px'
        iframemain.style.marginLeft = lnbWidth + 'px'
      } else {
        mainbody.style.marginLeft = 328 + 'px'
        iframemain.style.marginLeft = 328 + 'px'
      }
    })
  }
}
showMenu('.lnb-button', '.lnb-area', '.main-area', '.iframe-dashboard .main-area')

// 툴팁
const awaitingApprovalElements = document.querySelectorAll('.awaiting-approval')
const casenum = document.querySelectorAll('.awaiting-approval-button')
const closebtn = document.querySelectorAll('.awaiting-approval-content .tooltip-close')
for (let i = 0; i < awaitingApprovalElements.length; i++) {
  const awaitingApproval = awaitingApprovalElements[i]
  const casebtn = casenum[i]

  casebtn.addEventListener('click', function () {
    awaitingApproval.classList.toggle('active')

    for (let j = 0; j < awaitingApprovalElements.length; j++) {
      if (j !== i) {
        awaitingApprovalElements[j].classList.remove('active')
      }
    }
  })

  if (awaitingApproval.querySelector('.awaiting-approval-content')) {
    for (let q = 0; q < closebtn.length; q++) {
      closebtn[q].addEventListener('click', function (e) {
        let parentElement = e.target.parentElement.parentElement
        if (parentElement) {
          parentElement.classList.remove('active')
        }
        awaitingApproval.classList.remove('active')
      })
    }
  }
}

// /* lnb */
const depth1_item = document.querySelectorAll('.depth1-title')
const depth1 = document.querySelectorAll('.depth1-item')
const depth2_item = document.querySelectorAll('.depth2-title')
const depth2 = document.querySelectorAll('.depth2-item')

for (let i = 0; i < depth1_item.length; i++) {
  depth1_item[i].addEventListener('click', function () {
    for (let j = 0; j < depth1.length; j++) {
      depth1[j].classList.remove('active')
    }
    depth1[i].classList.add('active')
  })
}

for (let i = 0; i < depth2_item.length; i++) {
  depth2_item[i].addEventListener('click', function () {
    for (let j = 0; j < depth2.length; j++) {
      depth2[j].classList.remove('active')
    }
    depth2[i].classList.add('active')
  })
}

// // const dropdown = document.querySelector('.gnb .dropdown')
// // const toggleButton = document.querySelector('.gnb .dropdown-toggle')
// // const menu = document.querySelector('.gnb .dropdown-menu')
// // const options = document.querySelectorAll('.gnb .dropdown-option')

// // if (dropdown) {
// //   toggleButton.addEventListener('click', function () {
// //     dropdown.classList.toggle('show')
// //     menu.classList.toggle('show')
// //   })

// //   const closeDropdown = (e) => {
// //     if (
// //       !e.target.classList.contains('dropdown') &&
// //       !e.target.classList.contains('dropdown-option') &&
// //       !e.target.classList.contains('dropdown-toggle') &&
// //       !e.target.classList.contains('dropdown-menu')
// //     ) {
// //       menu.classList.remove('show')
// //       dropdown.classList.remove('show')
// //     }
// //   }

// //   window.addEventListener('click', (e) => closeDropdown(e))
// // }

// // for (let i = 0; i < options.length; i++) {
// //   options[i].addEventListener('click', function (e) {
// //     const value = e.currentTarget.textContent.trim()
// //     toggleButton.textContent = value
// //     toggleButton.classList.add('selected')
// //     menu.classList.remove('show')
// //     dropdown.classList.remove('show')
// //   })
// // }

const tabMenu = document.querySelectorAll('.tab-item')
const tabContent = document.querySelectorAll('.tab-content')

for (let idx = 0; idx < tabMenu.length; idx++) {
  tabMenu[idx].addEventListener('click', function (e) {
    e.preventDefault()

    for (let i = 0; i < tabMenu.length; i++) {
      tabMenu[i].classList.remove('active')
    }
    tabMenu[idx].classList.add('active')
    showContent(idx)
  })
  deleteTab(idx)
}

function showContent(num) {
  for (let i = 0; i < tabContent.length; i++) {
    tabContent[i].style.display = 'none'
  }
  tabContent[num].style.display = 'block'
}

function deleteTab(num) {
  const tabCloseButton = tabMenu[num].querySelectorAll('.tab-close')
  for (let i = 0; i < tabCloseButton.length; i++) {
    tabCloseButton[i].addEventListener('click', function (e) {
      let tabitem = e.target.parentElement
      tabitem.parentNode.removeChild(tabitem)

      let tabContentElement = tabContent[num]
      if (tabContentElement.parentNode) {
        tabContentElement.parentNode.removeChild(tabContentElement)
      }
    })
  }
}

// const maindropdown = document.querySelectorAll('.main .dropdown')
// // const mainmenu = dropdown.querySelector('.main .dropdown-menu')

// for (let i = 0; i < maindropdown.length; i++) {
//   const dropdown = maindropdown[i]
//   const toggleButton = dropdown.querySelector('.main .dropdown-toggle')
//   const menu = dropdown.querySelector('.main .dropdown-menu')
//   const options = dropdown.querySelectorAll('.main .dropdown-option')

//   toggleButton.addEventListener('click', function () {
//     menu.classList.toggle('show')
//     dropdown.classList.toggle('show')
//   })

//   for (let j = 0; j < options.length; j++) {
//     const option = options[j]
//     option.addEventListener('click', function (e) {
//       const value = e.currentTarget.value
//       toggleButton.textContent = value
//       menu.classList.remove('show')
//       dropdown.classList.remove('show')
//     })
//   }
// }
// // const closeDropdown2 = (e) => {
// //   if (
// //     !e.target.classList.contains('.main .dropdown') &&
// //     !e.target.classList.contains('.main dropdown-option') &&
// //     !e.target.classList.contains('.main dropdown-toggle') &&
// //     !e.target.classList.contains('.main dropdown-menu')
// //   ) {
// //     // mainmenu.classList.remove('show')
// //     maindropdown.classList.remove('show')
// //   }
// // }

// // window.addEventListener('click', function (e) {
// //   closeDropdown2(e)
// // })

// popup open
function popupOpen(e) {
  const target = document.querySelector(e)
  const overlay = target.querySelector('.overlay')
  const body = document.querySelector('body')
  target.classList.add('open')
  overlay.classList.add('active')
  body.classList.add('is-popup')
}

// popup close
function popupClose(e) {
  const target = document.querySelector(e)
  const overlay = target.querySelector('.overlay')
  const body = document.querySelector('body')
  target.classList.remove('open')
  overlay.classList.remove('active')
  body.classList.remove('is-popup')
}
let tabItem = document.querySelectorAll('.tab-list')
let tabList = document.querySelector('.tab-list')
let content = document.querySelector('.main-area')
function scrollWidth() {
  let sum = 0
  for (let i = 0; i < tabItem.length; i++) {
    sum += tabItem[i].offsetWidth
  }
  let scrollTotalWidth = sum
  tabList.style.width = scrollTotalWidth
}
if (document.querySelector('.tab-container')) {
  let contentWidth = content.offsetWidth
  let tabListWidth = tabList.scrollWidth

  if (contentWidth < tabListWidth) {
    scrollWidth()
    var swiper = new Swiper('.tab-container', {
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 0,
      mousewheel: true,
      observer: true,
      observeParents: true
    })
  }
}
